var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 801,
    height: 726,
    viewBox: "0 0 801 726",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_78)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 5.78516,
    width: 690,
    height: 697,
    rx: 24,
    fill: "url(#paint0_linear_21_78)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_21_78)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544.497 335.838C540.867 350.701 452.387 356.054 351.534 328.832C250.681 301.61 175.575 251.987 179.256 237.2C197.743 165.151 194.356 104.893 391.798 159.179C601.448 216.798 567.167 242.607 544.497 335.838Z",
    fill: "url(#paint1_linear_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M555.54 271.381C545.736 316.059 457.504 333.332 358.441 309.971C259.377 286.611 187.038 231.351 196.777 186.776C206.515 142.202 294.812 124.826 393.876 148.187C492.939 171.547 565.302 226.722 555.54 271.381Z",
    fill: "url(#paint2_radial_21_78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M555.54 271.381C545.736 316.059 457.504 333.332 358.441 309.971C259.377 286.611 187.038 231.351 196.777 186.776C206.515 142.202 294.812 124.826 393.876 148.187C492.939 171.547 565.302 226.722 555.54 271.381Z",
    fill: "url(#paint3_radial_21_78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M553.937 278.628C543.295 327.316 454.324 347.862 355.269 324.473C256.213 301.085 184.54 242.683 195.165 194.051C205.791 145.419 294.803 124.854 393.867 148.214C492.93 171.575 564.603 229.977 553.937 278.628Z",
    fill: "url(#paint4_radial_21_78)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428.465 54.5742L52.0601 57.9529L50.0985 64.9459L361.297 284.418L732.766 240.899L734.783 233.708L428.465 54.5742Z",
    fill: "url(#paint5_linear_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.9,
    d: "M363.3 277.283L361.298 284.418L50.0991 64.9461L52.0608 57.953L390.155 145.189L363.3 277.283Z",
    fill: "url(#paint6_linear_21_78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M361.299 284.418L732.768 240.899L734.785 233.708L399.347 144.683L388.654 145.806L363.3 277.283L361.299 284.418Z",
    fill: "url(#paint7_linear_21_78)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M428.465 54.5742L52.0601 57.9529L363.299 277.283L734.742 233.727L428.465 54.5742Z",
    fill: "url(#paint8_linear_21_78)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M396.971 160.965C396.971 160.965 223.17 158.876 203.024 164.25C182.878 169.624 153.287 218.401 126.511 232.177C72.5007 260.209 104.895 228.068 104.895 228.068C122.703 218.946 138.6 207.417 152.053 193.868C171.502 173.182 180.048 158.08 191.822 155.152C203.596 152.225 374.142 151.324 374.142 151.324L391.768 150.71L396.971 160.965Z",
    fill: "url(#paint9_radial_21_78)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M379.43 150.395C378.247 154.613 385.817 160.401 396.337 163.352C406.857 166.304 416.333 165.297 417.516 161.078C417.581 160.903 417.632 160.724 417.667 160.54L418.295 158.304L417.03 157.949C415.061 154.343 408.766 150.409 400.676 148.139C392.586 145.87 385.131 145.947 381.573 148.003L380.212 147.865L379.43 150.395Z",
    fill: "url(#paint10_linear_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M379.43 150.395C378.247 154.613 385.817 160.401 396.337 163.352C406.857 166.304 416.333 165.297 417.516 161.078L418.239 158.502L416.963 157.93C414.994 154.324 408.7 150.39 400.61 148.121C392.52 145.851 385.064 145.928 381.507 147.984L380.145 147.847L379.43 150.395Z",
    fill: "url(#paint11_linear_21_78)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M418.229 158.532C417.046 162.75 407.57 163.757 397.05 160.806C386.529 157.854 378.959 152.066 380.143 147.848C381.326 143.629 390.802 142.623 401.322 145.574C411.843 148.525 419.404 154.341 418.229 158.532Z",
    fill: "url(#paint12_linear_21_78)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4106 262.625C23.4106 262.625 64.583 265.379 89.257 256.664C113.931 247.949 122.555 235.77 121.298 232.058C120.04 228.346 110.089 219.141 79.3696 227.901C60.8507 233.173 41.418 236.263 21.5587 237.093C19.4517 243.068 19.8868 251.375 23.4106 262.625Z",
    fill: "url(#paint13_radial_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M20.3467 242.312C30.5545 242.703 40.6871 242.125 50.5651 240.588C62.4961 238.648 74.1172 235.776 85.2931 232.006C71.9996 238.118 57.5812 242.418 42.4973 244.769C35.1559 246.012 27.7115 246.91 20.1951 247.461C20.1286 245.735 20.1792 244.016 20.3467 242.312Z",
    fill: "url(#paint14_radial_21_78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M21.4285 255.106C23.4452 255.214 25.5112 255.274 27.593 255.278C39.9432 255.426 52.1906 254.61 64.1889 252.839C50.6971 256.23 36.5742 257.941 22.2183 257.924C21.8493 256.935 21.6135 255.983 21.4285 255.106Z",
    fill: "url(#paint15_radial_21_78)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_21_78)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M575.058 555.412L432.576 480.612L433.549 477.038L603.517 425.184L744.164 533.227L743.162 536.906L575.058 555.412Z",
    fill: "url(#paint16_linear_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M744.164 533.227L604.032 425.575L603.517 425.184L603.5 425.193L601.762 431.575L602.355 431.736L580.58 511.709L584.384 514.839L743.163 536.905L744.164 533.227Z",
    fill: "url(#paint17_linear_21_78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.9,
    d: "M601.762 431.575L603.5 425.193L433.549 477.038L432.576 480.612L581.001 512.34L602.395 431.747L601.762 431.575Z",
    fill: "url(#paint18_linear_21_78)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M575.059 555.411L432.576 480.612L602.519 428.849L743.139 536.885L575.059 555.411Z",
    fill: "url(#paint19_linear_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M664.373 548.233C659.398 571.073 620.143 581.773 576.694 572.135C533.245 562.497 502.063 536.165 507.048 513.342C512.033 490.519 551.291 479.806 594.727 489.44C638.162 499.075 669.358 525.41 664.373 548.233Z",
    fill: "url(#paint20_radial_21_78)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M658.116 574.298C656.644 579.705 618.279 578.586 572.525 567.747C526.77 556.909 491.138 539.752 492.383 535.177C503.241 495.301 499.194 467.674 588.762 489.254C683.862 512.244 668.324 526.344 658.116 574.298Z",
    fill: "url(#paint21_linear_21_78)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M658.116 574.298C656.333 581.91 617.801 579.335 572.032 568.548C526.263 557.762 490.6 542.845 492.369 535.229C494.139 527.614 532.685 530.193 578.45 540.992C624.215 551.791 659.869 566.692 658.116 574.298Z",
    fill: "url(#paint22_radial_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M578.45 540.992C532.685 530.193 494.136 527.627 492.369 535.229C490.603 542.831 526.263 557.762 572.032 568.548C617.801 579.335 656.333 581.91 658.116 574.298C659.899 566.686 624.233 551.726 578.45 540.992ZM572.642 565.936C566.988 564.606 561.376 563.176 555.937 561.695C513.097 550.031 495.161 539.102 495.09 535.858C496.996 532.259 527.108 531.662 577.833 543.63C583.487 544.96 589.102 546.377 594.541 547.858C637.381 559.522 655.303 570.447 655.384 573.708C653.482 577.295 623.361 577.875 572.645 565.923L572.642 565.936Z",
    fill: "url(#paint23_linear_21_78)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M667.321 474.206C667.321 474.206 687.693 488.827 693.205 509.371C699.66 533.466 700.376 557.394 715.047 572.557C729.718 587.721 744.881 590.453 744.881 590.453L745.943 586.554C736.161 583.752 727.315 578.405 720.376 571.098C713.437 563.79 708.673 554.806 706.607 545.13C701.521 523.39 700.637 482.076 667.321 474.206Z",
    fill: "url(#paint24_radial_21_78)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M768.028 596.685C768.028 596.685 749.374 597.107 737.93 592.134C726.486 587.161 722.229 580.753 722.753 578.83C723.277 576.906 727.515 572.545 741.77 577.711C750.331 580.811 759.25 582.831 768.304 583.721C769.339 586.879 769.355 591.071 768.028 596.685Z",
    fill: "url(#paint25_radial_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M768.905 586.454C764.273 586.418 759.65 585.889 755.119 584.878C749.661 583.639 744.317 581.936 739.151 579.79C745.365 583.159 752.036 585.638 758.954 587.151C762.305 587.958 765.693 588.597 769.106 589.063C769.094 588.191 769.027 587.32 768.905 586.454Z",
    fill: "url(#paint26_radial_21_78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M768.75 592.918C767.825 592.917 766.903 592.903 765.877 592.847C760.278 592.623 754.701 591.918 749.213 590.739C755.455 592.78 761.942 593.978 768.49 594.299C768.604 593.827 768.684 593.374 768.75 592.918Z",
    fill: "url(#paint27_radial_21_78)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_21_78)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.761 604.48C286.571 641.072 249.435 672.644 201.789 674.984C154.144 677.325 114.079 649.52 112.327 613.002C110.575 576.485 147.653 544.853 195.313 542.498C242.973 540.143 282.965 567.918 284.761 604.48Z",
    fill: "url(#paint28_linear_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M280.625 599.049C282.436 635.64 249.229 667.021 206.471 669.111C163.712 671.201 127.576 643.25 125.766 606.702C123.956 570.155 157.176 538.745 199.935 536.625C242.694 534.506 278.815 562.486 280.625 599.049Z",
    fill: "url(#paint29_radial_21_78)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M234.628 459.718L42.9571 529.457L42.4713 533.549L141.589 690.704L335.748 586.125L336.219 581.93L234.628 459.718Z",
    fill: "url(#paint30_linear_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.9,
    d: "M142.472 683.051L141.589 690.705L42.4709 533.549L42.9567 529.458L181.669 589.879L142.472 683.051Z",
    fill: "url(#paint31_linear_21_78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M141.589 690.704L335.748 586.125L336.219 581.93L185.408 588.583L181.08 590.379L142.089 686.494L141.574 690.674L141.589 690.704Z",
    fill: "url(#paint32_linear_21_78)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.628 459.719L42.9567 529.458L142.089 686.495L336.204 581.931L234.628 459.719Z",
    fill: "url(#paint33_linear_21_78)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M191.706 563.473C170.098 604.539 137.702 639.335 93.0884 659.147L94.4426 650.153C137.128 635.302 170.496 597.047 186.893 557.423L191.706 563.473Z",
    fill: "url(#paint34_radial_21_78)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M197.55 563.076V561.206H197.02C196.21 559.936 195.093 558.89 193.772 558.166C192.451 557.441 190.968 557.062 189.462 557.062C187.955 557.062 186.473 557.441 185.152 558.166C183.831 558.89 182.714 559.936 181.904 561.206H181.359V563.385C181.359 563.385 181.359 563.502 181.359 563.561C181.359 567.153 184.995 570.052 189.484 570.052C193.973 570.052 197.594 567.109 197.594 563.561C197.588 563.399 197.574 563.237 197.55 563.076Z",
    fill: "url(#paint35_linear_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M197.55 563.076V561.206H197.02C196.21 559.936 195.093 558.89 193.772 558.166C192.451 557.441 190.968 557.062 189.462 557.062C187.955 557.062 186.473 557.441 185.152 558.166C183.831 558.89 182.714 559.936 181.904 561.206H181.359V563.385C181.359 563.385 181.359 563.502 181.359 563.561C181.359 567.153 184.995 570.052 189.484 570.052C193.973 570.052 197.594 567.109 197.594 563.561C197.588 563.399 197.574 563.237 197.55 563.076Z",
    fill: "url(#paint36_linear_21_78)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M197.58 561.633C197.58 565.431 193.945 568.522 189.47 568.522C184.996 568.522 181.345 565.431 181.345 561.633C181.345 557.836 184.981 554.73 189.47 554.73C193.959 554.73 197.58 557.821 197.58 561.633Z",
    fill: "url(#paint37_linear_21_78)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3422 660.177C46.3422 660.177 66.0656 666.241 79.6513 664.18C93.237 662.12 99.6103 656.364 99.6103 654.098C99.6103 651.831 96.3574 645.752 79.7102 647.15C69.7154 648.004 59.652 647.559 49.7717 645.826C47.7993 648.976 46.5777 653.597 46.3422 660.177Z",
    fill: "url(#paint38_radial_21_78)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M48.3729 648.652C53.3111 649.982 58.3802 650.767 63.4894 650.993C69.664 651.266 75.8507 650.991 81.9765 650.168C74.4117 652.057 66.6117 652.83 58.8234 652.465C55.027 652.346 51.2392 652.031 47.4751 651.523C47.7171 650.549 48.0169 649.59 48.3729 648.652Z",
    fill: "url(#paint39_radial_21_78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M46.6801 655.806C47.6515 656.085 48.6524 656.35 49.6239 656.586C55.6347 658.026 61.7629 658.923 67.9344 659.265C60.7297 659.633 53.5087 659.009 46.474 657.41C46.5623 656.88 46.6212 656.336 46.6801 655.806Z",
    fill: "url(#paint40_radial_21_78)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_78",
    x: 61,
    y: 0.785156,
    width: 710,
    height: 717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_78"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_78",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_21_78",
    x: 0.166748,
    y: 49.5742,
    width: 754.618,
    height: 333.549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_78"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_78",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_21_78",
    x: 401.174,
    y: 417.334,
    width: 399.333,
    height: 234.313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23.5512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_78"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_78",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_21_78",
    x: 22.4709,
    y: 454.718,
    width: 333.748,
    height: 270.986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_78"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_78",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_78",
    x1: 416,
    y1: 5.78516,
    x2: 416,
    y2: 702.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D40D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0003AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_78",
    x1: 191.542,
    y1: 189.316,
    x2: 554.8,
    y2: 302.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(606.126 -48.3109) rotate(15.6696) scale(189.608 107.496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(606.126 -48.3109) rotate(15.6696) scale(189.608 107.496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(580.5 86.5771) rotate(15.6696) scale(189.489 107.429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21_78",
    x1: 313.252,
    y1: 325.881,
    x2: 432.182,
    y2: 29.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_21_78",
    x1: 173.612,
    y1: 244.901,
    x2: 243.469,
    y2: 70.5422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_21_78",
    x1: 563.331,
    y1: 137.605,
    x2: 531.384,
    y2: 328.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_21_78",
    x1: 195.721,
    y1: 216.776,
    x2: 621.308,
    y2: -17.5898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.262 114.98) rotate(15.6696) scale(219.807 186.926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_21_78",
    x1: 380.711,
    y1: 150.693,
    x2: 407.745,
    y2: 158.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C95D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#727AA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#585D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#42465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#313343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#252630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1D1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_21_78",
    x1: 393.408,
    y1: 166.623,
    x2: 401.528,
    y2: 146.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_21_78",
    x1: 380.143,
    y1: 147.848,
    x2: 418.229,
    y2: 158.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8479 217.241) rotate(-118) scale(85.846 87.624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9046 238.833) rotate(168.907) scale(83.2927 76.3299)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.6191 259.817) rotate(168.907) scale(44.2607 40.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_21_78",
    x1: 603.783,
    y1: 393.454,
    x2: 578.2,
    y2: 570.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_21_78",
    x1: 677.117,
    y1: 414.006,
    x2: 659.511,
    y2: 535.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_21_78",
    x1: 526.223,
    y1: 392.621,
    x2: 509.013,
    y2: 511.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_21_78",
    x1: 602.909,
    y1: 398.046,
    x2: 578.045,
    y2: 569.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(620.964 411.134) rotate(15.2309) scale(73.9201 47.575)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#393434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#534F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#969494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_21_78",
    x1: 499.744,
    y1: 506.495,
    x2: 664.359,
    y2: 551.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(612.636 626.401) rotate(15.2309) scale(135.082 130.408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_21_78",
    x1: 493.137,
    y1: 532.409,
    x2: 657.335,
    y2: 577.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(705.08 523.703) rotate(15.2309) scale(78.7665 76.0413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(754.431 572.837) rotate(-66.4356) scale(40.8793 42.2839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(752.937 579.454) rotate(15.2309) scale(38.9158 37.5693)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(760.83 590.51) rotate(15.2309) scale(20.6788 19.9634)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_21_78",
    x1: 92.7102,
    y1: 389.926,
    x2: 251.933,
    y2: 389.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.951 378.79) scale(79.6537 79.6537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_21_78",
    x1: 141.678,
    y1: 749.356,
    x2: 218.911,
    y2: 429.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_21_78",
    x1: 75.7323,
    y1: 706.256,
    x2: 117.77,
    y2: 532.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_21_78",
    x1: 229.241,
    y1: 560.19,
    x2: 245.417,
    y2: 687.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_21_78",
    x1: -0.100603,
    y1: 706.531,
    x2: 320.623,
    y2: 458.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.648 601.58) scale(89.8303 89.8303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_21_78",
    x1: 188.13,
    y1: 573.055,
    x2: 190.338,
    y2: 555.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_21_78",
    x1: 188.13,
    y1: 573.055,
    x2: 190.338,
    y2: 555.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_21_78",
    x1: 181.345,
    y1: 561.633,
    x2: 197.58,
    y2: 561.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.2042 638.022) rotate(-98.12) scale(46.6151 46.6152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.3752 645.723) rotate(180) scale(42.8619 42.8618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_21_78",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7765 655.526) rotate(180) scale(22.7851 22.7851)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.7b22d2aa9de4c95dbc13d3a7e5a191b6.svg";
export { ForwardRef as ReactComponent };